import React, { Component } from "react";
import { Link } from "react-router-dom";
import textosJSON from "./textosMenu.json";

const SubmenuIdiomas = ({ mobile, ocultarMenu, idioma, path }) => {
  const texto = (nombre) => {
    return (textosJSON[nombre]?.[idioma])??(textosJSON[nombre]?.["es"])??""
  }
  const idiomas = ["es","en"].filter((i) => (mobile || (i != idioma)));

  return (
    <div 
    style={mobile?
    {
      position: "relative",
      left: "5%",
      top: 25,
      width: "100%",
      backgroundColor: "#242e37",
    }:
    {
      position: "absolute",
      marginTop: -32,
      width: 72,
      height: 72,
      background: "rgba(217, 217, 217, 0.05)",
      paddingLeft: 12,
      paddingTop: 44,
      paddingBottom: 12,
      paddingRight: 12,
      marginLeft: -12,
      borderRadius: 5,
    }}>
      {idiomas.map((i) => {
        return (
        <Link className="subItemNavBar" to={"/" + i + "/" + path} onClick={ocultarMenu} style={{display: "flex"}}>
          {i.toUpperCase()}
          <img 
            src={require("../../../res/iconos/" + i + ".png")}
            className="bandera_idioma"
            style={{
              position: "relative",
              objectFit: "cover",
              objectPosition: "center",
              width: 16,
              height: 11,
              margin: "auto",
              marginLeft: 11,
              zIndex: 0,
            }}
          />
        </Link>
        )
      })}
    </div>
  );
};

export default SubmenuIdiomas;
